import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Avatar, Box, Card, CardContent, Grid, ListItem, ListItemAvatar } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const mock = [
	{
		headerSlide: 'Why is a nanny needed, when I have family to handle my child?',
		avatar: 'https://babysparks.com/wp-content/uploads/2019/09/20222a-1.jpg',

		subSlideLine1: 'Raising a special needs child is both a blessing and a lot of hard work.',
		subSlideLine2: 'Occasionally, you need or could use help, on occassional days if not all.',
		subSlideLine3:
			'If you are tired of finding the right nannies and/or confident that you have the right nanny to take care of your precious ones, we are here to help.',
		subSlideLine4: '',
		subSlideLine5: '',

		headerBodySlide: 'We offer:',

		bodySlideLine1: 'Verified, experiences nannies that are specialized in babysitting special needs children',
		bodySlideLine2: 'Smooth, fast booking support from our administration team.',
		bodySlideLine3: 'A variety of engagement formats (hourly to yearly), with quality support.',
		bodySlideLine4: '',
		bodySlideLine5: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		CTAType1: 'CTA',
		CTAText1: 'Start Now',
		CTALink1: '/contact'
	}
];

const NannyServicesDescription = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0,
				'&::after': {
					position: 'absolute',
					content: '""',
					width: '30%',
					zIndex: 1,
					top: 0,
					right: 0,
					height: '100%',
					backgroundSize: '18px 18px',
					backgroundImage: `radial-gradient(${alpha(theme.palette.primary.dark, 0.4)} 20%, transparent 20%)`,
					opacity: 0.2
				}
			}}>
			<Box position={'relative'} zIndex={2} paddingTop={4} marginX={{ xs: 2, sm: 2, md: 2 }}>
				<Box paddingX={1} marginY={0} paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginY={0}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 16, sm: 7, md: 7, lg: 8 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<Box>
							{mock.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box marginBottom={2}>
													<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
														{item.headerSlide}
													</SimTypography>

													<SimTypography color='text.primary'>
														{item.subSlideLine1 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine1}</Box>
														)}
														{item.subSlideLine2 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine2}</Box>
														)}
														{item.subSlideLine3 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine3}</Box>
														)}
														{item.subSlideLine4 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine4}</Box>
														)}
														{item.subSlideLine5 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine5}</Box>
														)}
													</SimTypography>
												</Box>

												<Grid container spacing='2px'>
													<SimTypography>
														{item.headerBodySlide === '' ? (
															<Box>
																{' '}
																<br />
															</Box>
														) : (
															<Box> {item.headerBodySlide} </Box>
														)}
													</SimTypography>

													{[
														{ line: item.bodySlideLine1, link: item.LinkForBodyLine1 },
														{ line: item.bodySlideLine2, link: item.LinkForBodyLine2 },
														{ line: item.bodySlideLine3, link: item.LinkForBodyLine3 },
														{ line: item.bodySlideLine4, link: item.LinkForBodyLine4 },
														{ line: item.bodySlideLine5, link: item.LinkForBodyLine5 }
													].map((item2, i2) => (
														<Grid item xs={12} key={i2}>
															<Box
																component={ListItem}
																disableGutters
																width={'auto'}
																padding={0}
																margin={0}
																display={'flex'}
																flexDirection={'row'}
																alignItems={'flex-start'}
																justifyItems={'left'}>
																{item2.line === '' ? (
																	<Box></Box>
																) : (
																	<Box
																		display={'flex'}
																		flexDirection={'row'}
																		alignItems={'center'}
																		justifyItems={'center'}>
																		<Box
																			component={ListItemAvatar}
																			minWidth={'auto !important'}
																			marginRight={2}
																			marginTop={'0.7em'}>
																			<Box
																				component={Avatar}
																				bgcolor={theme.palette.secondary.main}
																				width={20}
																				height={20}>
																				<svg
																					width={12}
																					height={12}
																					xmlns='http://www.w3.org/2000/svg'
																					viewBox='0 0 20 20'
																					fill='currentColor'>
																					<path
																						fillRule='evenodd'
																						d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
																						clipRule='evenodd'
																					/>
																				</svg>
																			</Box>
																		</Box>
																	</Box>
																)}

																<SimTypography padding={'8px'}>
																	{item2.line}
																</SimTypography>
															</Box>
														</Grid>
													))}
												</Grid>

												<Box display={'flex'} justifyContent={'flex-end'}>
													<SimButton
														variant='contained'
														backgroundColor={
															item.CTAType1 === 'CTA'
																? theme.palette.background.btnPrimaryCTA
																: theme.palette.background.btnSecondaryCTA
														}
														color={
															item.CTAType1 === 'CTA'
																? theme.palette.text.btnPrimaryCTA
																: theme.palette.text.btnSecondaryCTA
														}
														href={item.CTALink1}>
														{item.CTAText1}
													</SimButton>
												</Box>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { NannyServicesDescription };
